import * as Yup from 'yup';

export const validateionSchema = Yup.object().shape({
  password: Yup.string().required(),
  second_password: Yup.string().required(),
});
